/**
 * "Show N more" under Recents or Settled: a quiet row whose words start on
 * the rows' label column. A tree item at the level of the rows it reveals.
 *
 * @module components/home/RecentsShowMore
 */
export function RecentsShowMore({
  count,
  level,
  onClick,
  tabIndex,
  onFocus,
}: {
  readonly count: number;
  readonly level: 1 | 2;
  readonly onClick: () => void;
  readonly tabIndex: number;
  readonly onFocus: () => void;
}) {
  return (
    <li role="none" className="list-none">
      <button
        type="button"
        role="treeitem"
        aria-level={level}
        tabIndex={tabIndex}
        onFocus={onFocus}
        data-recents-show-more=""
        onClick={onClick}
        className="flex h-8 w-full items-center rounded-md ps-[34px] pe-2.5 text-left text-xs text-sidebar-foreground/56 hover:bg-sidebar-row-hover"
      >
        Show {count} more
      </button>
    </li>
  );
}
